import {atom} from "jotai";

// Whether the registry project's test chat drawer (TestChatDrawer) is open. Opened by the header's Start
// button and by the flow designer's START node.
export const TestChatOpenAtom = atom(false);
